<template>
  <teleport to="body">
    <div v-if="show" class="hover-info">
      <div
          ref="tooltip"
          class="content"
          :style="{ top: position.top + 'px', left: position.left + 'px' }"
      >
        <p>{{ content }}</p>
        <AngledBackground :color="'#00002f'" :opacity="0.75"></AngledBackground>

      </div>
    </div>
  </teleport>
</template>

<script>
import {ref, onMounted, onUpdated, onUnmounted, computed} from "vue";
import AngledBackground from "@/components/UI/AngledBackground.vue";

export default {
  name: "HoverInfo",
  components: {AngledBackground},

  props: {
    show: {type: Boolean, default: false},
    content: {type: String, default: ""},
    offsetX: {type: Number, default: 12},
    offsetY: {type: Number, default: 12}
  },

  setup(props) {
    const mouseX = ref(0);
    const mouseY = ref(0);
    const tooltipWidth = ref(0);
    const tooltipHeight = ref(0);
    const tooltip = ref(null);

    const measureTooltip = () => {
      if (!tooltip.value) return;
      const rect = tooltip.value.getBoundingClientRect();
      tooltipWidth.value = rect.width;
      tooltipHeight.value = rect.height;
    };

    const trackMouse = (e) => {
      mouseX.value = e.clientX;
      mouseY.value = e.clientY;
    };

    const position = computed(() => {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      let left = mouseX.value + props.offsetX;
      let top = mouseY.value + props.offsetY;

      if (left + tooltipWidth.value > viewportWidth) {
        left = mouseX.value - tooltipWidth.value - props.offsetX;
      }

      if (top + tooltipHeight.value > viewportHeight) {
        top = mouseY.value - tooltipHeight.value - props.offsetY;
      }

      return {left, top};
    });

    onMounted(() => {
      window.addEventListener("mousemove", trackMouse);
      measureTooltip();
    });

    onUpdated(() => {
      measureTooltip();
    });

    onUnmounted(() => {
      window.removeEventListener("mousemove", trackMouse);
    });

    return {tooltip, position};
  }
};
</script>

<style scoped>
.hover-info {
  position: fixed;
  left: 0;
  top: 0;
  pointer-events: none;
  z-index: 9999;
}

.content {
  position: absolute;
  padding: 10px 12px;
  border-radius: 5px;
  text-align: center;
  min-width: 180px;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: bold;
  z-index: 1;
  p {
    color: #fff;
    opacity: 1;
    z-index: 1;
  }
}

.content p {
  margin: 0;
}
</style>
